import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow, ItemIcon } from "@similarweb/ui-components";

export const Container = styled(FlexColumn)`
    gap: 24px;

    /* TODO: Why the disabled style is not applied by default in DropdownButton component? */
    .DropdownButton--disabled .DropdownButton-text {
        opacity: 0.4;
    }
`;

export const Label = styled.label`
    ${setFontVariant("caption", colorsPalettes.carbon[300])};
    margin-bottom: 4px;
`;

/** Styled as an in-menu action row (e.g. "Connect another account"), not a standalone page button. */
export const AccountDropdownFooter = styled.button`
    display: flex;
    align-items: center;
    width: 100%;
    padding: 18px 24px;
    border: none;
    border-top: 1px solid ${colorsPalettes.carbon[100]};
    background: ${colorsPalettes.carbon["0"]};
    color: ${colorsPalettes.blue[400]};
    cursor: pointer;

    ${setFontVariant("input2")};
    font-weight: 500;

    &:hover {
        background-color: ${colorsPalettes.carbon[25]};
    }
`;

/** Targets internal ui-components class to toggle text color between value/placeholder states. */
export const DropdownWrapper = styled.div<{ hasValue: boolean; hasError?: boolean }>`
    display: flex;
    flex-direction: column;

    .DropdownButton .DropdownButton-text {
        color: ${({ hasValue }) => (hasValue ? colorsPalettes.carbon[400] : colorsPalettes.carbon[200])};
        text-indent: 0;
        padding-right: 16px;
        padding-left: 16px;
    }

    ${({ hasError }) =>
        hasError &&
        `
        .DropdownButton {
            border: 1px solid ${colorsPalettes.red["400_P"]};
        }
    `}
`;

export const ErrorMessage = styled.span`
    ${setFontVariant("caption", colorsPalettes.red["400_P"])};
    margin-top: 4px;
`;

export const ReconnectAction = styled.button`
    ${setFontVariant("caption", colorsPalettes.blue[400])};
    padding: 0;
    background: none;
    border: none;
    cursor: pointer;

    &:hover {
        color: ${colorsPalettes.blue[500]};
    }
`;

export const DropdownItem = styled(FlexRow)`
    align-items: center;
    gap: 8px;
`;

export const SmallItemIcon = styled(ItemIcon)`
    height: 24px;
    width: 24px;
`;
